module.exports = __webpack_public_path__ + "img/l-cb6-r2.d90fc593.gif";